export enum OddValueChange {
    'up1' = 1,
    'up2' = 2,
    'down1' = -1,
    'down2' = -2,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/sportOffer/enums.ts